import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import VisionBanner from "../../../images/visionbanner.png";
import ValueBanner from "../../../images/valuebanner.png";
import OurPeopleBanner from "../../../images/ourpeoplebanner.png";
import reachout from '../../../images/Inner Page/reach-out.jpg'
function ReachOutBanner(props) {

    const [ReachOutImgBanner, setReachOutImgBanner] = useState(VisionBanner);
    const [ReachOutHead, setReachOutHead] = useState('');
    useEffect(() => {
      if (props.id === 1) setReachOutImgBanner(VisionBanner);
      if (props.id === 2) setReachOutImgBanner(ValueBanner);
      if (props.id === 3) setReachOutImgBanner(OurPeopleBanner);
      if (props.id === 1) setReachOutHead('Reach Out');
      if (props.id === 2) setReachOutHead('Customers Services');
      if (props.id === 3) setReachOutHead('Company Details');
    }, [props.id]);
  return (
    <>
    
    <section className="banner-sc download-banner">
        {/* <section className="home-banner-main">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="banner-content">
                  <h1>{ReachOutHead}</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </section> */}

              <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={reachout}
                  alt="Reach Us Banner"
                  className="banner-image"
                />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">Reach Us</h1>
                  </div>
                </div>
              </div>
            </div>
        </section>
      </section>
    </>
  )
}

export default ReachOutBanner